import { PaperSection, Flex } from '@shared/components';

import { ItemAnalysisTab, type ItemAnalysisTabType } from '../../constants';
import { useItemAnalysisSearchParams } from '../../hooks';
import { ItemAnalysisDiscriminantTable } from '../item-analysis-discriminant-table';
import { ItemAnalysisFilterSection } from '../item-analysis-filter-section';
import { ItemAnalysisNavigationTabs } from '../item-analysis-navigation-tabs';
import { ItemAnalysisReportExportButton } from '../item-analysis-report-export-button';
import { ItemAnalysisResponseStatisticsTable } from '../item-analysis-response-statistics-table';
import { PAnalysisList } from '../p-analysis-list';
import { QBankOverviewList } from '../qbank-overview-list';

function getTabTableContent(input: ItemAnalysisTabType) {
  switch (input) {
    case ItemAnalysisTab.DiscriminantAnalysis:
      return <ItemAnalysisDiscriminantTable />;
    case ItemAnalysisTab.QBankOverview:
      return <QBankOverviewList />;
    case ItemAnalysisTab.ResponseStatistics:
      return <ItemAnalysisResponseStatisticsTable />;
    case ItemAnalysisTab.PAnalysis:
      return <PAnalysisList />;
    default:
      return null;
  }
}
export default function ItemAnalysisSection() {
  const [{ navigationTab }] = useItemAnalysisSearchParams();
  return (
    <PaperSection
      title='รายงานวิเคราะห์คุณภาพข้อสอบ: แบบรายข้อ'
      endAdornment={<ItemAnalysisReportExportButton />}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: (theme) => theme.spacing(6),
          p: (theme) => theme.spacing(4),
        }}
      >
        <ItemAnalysisFilterSection />
        <ItemAnalysisNavigationTabs />
        {getTabTableContent(navigationTab)}
      </Flex>
    </PaperSection>
  );
}
